import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
            status: false,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
    }
    return ApiService.get('/invoice/invoiceuploads/', datas)
}
export const getApiRecord = (id) =>
    ApiService.get(`/invoice/invoicedata/view/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.filePut(`/invoice/invoicedata/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/invoice/invoiceuploads/${id}/`, data)
export const getApiResult = (data) => {
    var datas
    if (data) {
        datas = {
            invoice_num: data.invoice_num,
        }
        if (data?.version) {
            datas.version_no = data.version
        }
    }
    return ApiService.get(`/rate-card-template/combined-api/`, datas)
}
// export const getApiResult = (id) =>
//     ApiService.post(`/invoice/invoicedata/results/${id}/`)
export const createApiRecord = (data) =>
    ApiService.filePost('/invoice/invoiceuploads/', data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/invoice/invoiceuploads', id)
export const sendMailApi = (data) =>
    ApiService.post('/rate-card-template/send-mail/', data)
export const sendApprovedRejectMailApi = (data) =>
    ApiService.post(
        '/rate-card-template/approved-rejected-invoice-send-mail/',
        data,
    )
export const downloadCsvApi = (id, filter) => {
    const filterString = filter
        ? filter.map((num) => `status=${num}`).join('&')
        : ''
    return ApiService.get(
        `/invoice/invoice-data-csv-export/?invoice_id=${id}${filterString ? `&${filterString}` : ''}`,
    )
}
